<nav class="navbar head-nav">
    <h2>{{ 'dashboard.workflow_setting' | translate }}</h2>
    <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]='["/"]'>{{ 'header.home' | translate }}</a></li>
        <li class="breadcrumb-item">{{ 'dashboard.workflow_setting' | translate }}</li>
    </ol>
</nav>

<div class="app--content-container">
    <div class="container-fluid p-0">
        <div class="page">
            <div class="page-filters">

                <div class="sort-item">
                  <span class="count-page" *ngIf='!dataLoading'>
                    <span class="px-1">{{recordsData.length}}</span>{{ 'dashboard.workflow_setting' | translate }}
                  </span>
                </div>
              
                <div class="filters-container">
                  <div class="search-input">
                      <mat-form-field *ngIf="showSearch">
                          <input matInput autocomplete="off" [(ngModel)]="filterModel.search" (keyup)="makeSearch()">
                          <mat-icon (click)="resetSearch(); showSearch = false;" matSuffix>clear</mat-icon>
                      </mat-form-field>
                      <button mat-icon-button (click)="makeSearch()">
                          <mat-icon>search</mat-icon>
                      </button>
                  </div>
                  
                  <div class="create-item">
                    <a class="customBtn" mat-raised-button color="primary"
                    appAccessControl [accessRoles]="actions.WorkflowSettingsCreate"
                    [routerLink]='["/admin/workflowSetting/create-workFlow-setting"]' 
                    >
                        <span>{{'forms.add_new'|translate}}</span>
                    </a>
                </div>

              </div>
             
             </div>
             <div *ngIf='dataLoading' class="dataLoading">
              <mat-spinner class="m-auto" diameter="50"></mat-spinner>
            </div>

            <ng-container *ngIf='!dataLoading'>
              <div *ngIf="recordsData && recordsData.length; else dataEmpty">
                <div class="table-container table-responsive">
                
                  <table mat-table [dataSource]="dataSource" matSort>

                    <ng-container matColumnDef="orgName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Organization">
                          {{ 'workflow_settings.organization' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.orgName}} </td>
                      </ng-container>

                    <ng-container matColumnDef="whName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Warehouse">
                        {{ 'workflow_settings.warehouse' | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element"> {{element.whName}} </td>
                    </ng-container>

                      <ng-container matColumnDef="workflowType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Workflow Type">
                          {{ 'workflow_settings.workflow_type' | translate }} 
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.workflowType}} </td>
                      </ng-container>

                      <ng-container matColumnDef="workflowName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Workflow Name">
                          {{ 'workflow_settings.workflow_name' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.workflowName}} </td>
                      </ng-container>

                      <ng-container matColumnDef="fullName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Full Name">
                          {{ 'workflow_settings.full_name' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element"> {{element.fullName}} </td>
                      </ng-container>

                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ 'workflow_settings.action' | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <div class="btn-actions">
                          <button mat-icon-button [matTooltip]="'Delete'" (click)="deleteRecord(element)" 
                           appAccessControl [accessRoles]="actions.WorkflowSettingsDelete">
                            <svg width="16" height="20.002" viewBox="0 0 16 20.002">
                              <path id="delete-icon"
                                d="M4422.4,17833.639a1.853,1.853,0,0,1-1.844-1.785l-.51-10.822a.2.2,0,0,1,.192-.207H4433.9a.194.194,0,0,1,.192.207l-.505,10.822a1.859,1.859,0,0,1-1.844,1.785Zm7.134-11.252v8.129a.616.616,0,1,0,1.231,0v-8.129a.616.616,0,1,0-1.231,0Zm-3.079,0v8.129a.615.615,0,1,0,1.23,0v-8.129a.615.615,0,1,0-1.23,0Zm-3.075,0v8.129a.615.615,0,1,0,1.23,0v-8.129a.615.615,0,1,0-1.23,0Zm-3.692-2.811a.621.621,0,0,1-.618-.627v-1.248a1.551,1.551,0,0,1,1.54-1.562h3.383v-.627a1.864,1.864,0,0,1,1.849-1.875h2.461a1.86,1.86,0,0,1,1.844,1.875v.627h3.383a1.551,1.551,0,0,1,1.54,1.563v1.248a.617.617,0,0,1-.613.627Zm5.536-4.064v.627h3.692v-.627a.616.616,0,0,0-.613-.621h-2.461A.619.619,0,0,0,4425.223,17815.512Z"
                                transform="translate(-4419.069 -17813.637)" fill="#616e7c" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </ng-container>
                   
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns:displayedColumns;"></tr>
      
                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                      <td class="mat-cell" colspan="6">{{ 'swalMsg.no_data_matching_the_filter' | translate }} "{{filterModel.search}}"</td>
                    </tr>
                  </table>
                </div>
                <div class="pagination-container">
                  <mat-paginator [length]="recordsData.length" [pageSize]="filterModel.PageSize"
                    [pageSizeOptions]="[10,100, 500]" [pageIndex]="pageIndex">
                  </mat-paginator>
                </div>
              </div>
            </ng-container>

        </div>
    </div>
</div>

<ng-template #dataEmpty>
  <app-empty-state [title]='"table.no_data_found" | translate'></app-empty-state>
</ng-template>